import React from 'react'

import Modal from '@groovehq/internal-design-system/lib/components/Modal/Modal'

import Container from './Container'
import { styles } from './styles'

const Variant5 = ({ page, children }) => {
  return (
    <>
      <Modal
        portal="#drawer-root"
        open
        css={styles.panel}
        className={page === 'V6EmailPage' ? 'grui mt-14' : 'grui mt-21'}
        backdropStyles={styles.backdrop}
        panelCenter={page === 'V6SignupPage'}
      >
        <div css={styles.blob1} />
        <div css={styles.blob2} />
        <div css={styles.blob3} />
        <div className="grui w-100">
          <Container>{children}</Container>
        </div>
        <p className="grui pb-12 m-0" css={styles.copy}>
          By signing up you agree to Groove’s{' '}
          <a
            className="grui"
            href="https://www.groovehq.com/our/terms"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Service
          </a>{' '}
          and{' '}
          <a
            className="grui"
            href="https://www.groovehq.com/our/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          .
        </p>
      </Modal>
    </>
  )
}

export default Variant5
